export const ServiceList = [
  { id: 0, service: "SELECCIONE" },
  { id: 1, service: "COMPARTIDO" },
  { id: 2, service: "PRIVADO" },
];
